import { Button, Card, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Select from 'react-select';
import { breakpointsMediaQuery, useMediaQuery } from '@/helpers/utils';
import type {
  ColumnSelectOption,
  ColumnSelectOptionProps,
  FiltersComponentSkeletonProps
} from './filterTypes';

const FiltersComponentSkeleton = ({
  EndComponent = <></>
}: FiltersComponentSkeletonProps) => {
  const isLgUp = useMediaQuery(breakpointsMediaQuery.lg);
  return (
    <Card className="mb-3 fs--2 fs-lg-0">
      <Card.Body className="align-items-center">
        {isLgUp ? (
          <div>
            <div className="d-flex align-items-center gap-2 flex-wrap">
              <div
                style={{
                  maxWidth: 600,
                  zIndex: 3
                  // width: 'unset !important'
                }}
                className="input-group position-relative"
              >
                <div>
                  <Select<ColumnSelectOption, false>
                    components={{ Option: OptionLayout }}
                    styles={{
                      control: baseStyles => ({
                        ...baseStyles,
                        paddingLeft: '0px',
                        paddingRight: '10px',
                        color: 'var(--falcon-emphasise) !important',
                        boxShadow: 'none !important',
                        width: isLgUp ? '200px !important' : '100%',
                        cursor: 'pointer',
                        minHeight: '30px !important',
                        borderRadius: ' 0px 5px 5px 0px !important'
                      }),
                      input: baseStyles => ({
                        ...baseStyles,
                        color: 'var(--falcon-emphasise) !important',
                        boxShadow: 'none !important'
                      })
                    }}
                    closeMenuOnSelect={true}
                    options={[]}
                    placeholder="درحال بارگذاری..."
                    classNamePrefix="react-select"
                    noOptionsMessage={() => 'موردی یافت نشد!!!'}
                    value={null}
                  />
                </div>
                <Form.Control
                  style={{ zIndex: 3 }}
                  type="text"
                  placeholder="درحال بارگذاری..."
                  name="start_url"
                  size={isLgUp ? undefined : 'sm'}
                  disabled
                />
                <Button
                  style={{ borderRadius: '5px 0 0 5px' }}
                  variant="outline-secondary"
                  disabled
                  title="جستجو"
                  size={isLgUp ? undefined : 'sm'}
                >
                  <FontAwesomeIcon icon="search" />
                </Button>
                <div className="mx-1">
                  <Button
                    size={isLgUp ? 'lg' : 'sm'}
                    disabled
                    variant="outline-primary"
                    className="fs-0 h-100 mt-xxl-0"
                  >
                    <span className="d-flex align-items-center gap-1">
                      <FontAwesomeIcon icon="plus" />
                      <span className="d-none d-md-inline">فیلتر بیشتر</span>
                    </span>
                  </Button>
                </div>
              </div>
              {EndComponent}
            </div>
          </div>
        ) : (
          <div className="d-flex gap-2 align-items-center gap-2 flex-wrap">
            <div
              style={{
                minWidth: '100%',
                zIndex: 3,
                width: 'unset !important'
              }}
              className="position-relative"
            >
              <div className="mb-3">
                <Select<ColumnSelectOption, false>
                  components={{ Option: OptionLayout }}
                  styles={{
                    control: baseStyles => ({
                      ...baseStyles,
                      paddingLeft: '0px',
                      paddingRight: '10px',
                      color: 'var(--falcon-emphasise) !important',
                      boxShadow: 'none !important',
                      width: isLgUp ? '200px !important' : '100%',
                      cursor: 'pointer',
                      minHeight: '30px !important',
                      borderRadius: ' 0px 5px 5px 0px !important'
                    }),
                    input: baseStyles => ({
                      ...baseStyles,
                      color: 'var(--falcon-emphasise) !important',
                      boxShadow: 'none !important'
                    })
                  }}
                  closeMenuOnSelect={true}
                  options={[]}
                  placeholder="درحال بارگذاری..."
                  classNamePrefix="react-select"
                  noOptionsMessage={() => 'موردی یافت نشد!!!'}
                  value={null}
                />
              </div>
              <div className="input-group w-100">
                <Form.Control
                  style={{ zIndex: 3 }}
                  type="text"
                  placeholder="درحال بارگذاری..."
                  name="start_url"
                  disabled
                />
                <Button
                  className="border-300"
                  disabled
                  style={{
                    borderRadius: '5px 0px 0px 5px',
                    height: '100%'
                  }}
                  variant="outline-secondary"
                  title="جستجو"
                >
                  <FontAwesomeIcon icon="search" />
                </Button>
              </div>
              <Button
                size={isLgUp ? 'lg' : 'sm'}
                variant="outline-primary"
                style={{
                  height: '36px'
                }}
                className="fs-0 mt-xxl-0 mt-2"
              >
                <span className="d-flex align-items-center gap-1">
                  <FontAwesomeIcon icon="plus" />
                  <span className="d-none d-md-inline">فیلتر بیشتر</span>
                </span>
              </Button>
            </div>
          </div>
        )}
        <style>
          {`
            .customized-option:hover{
              background-color:black!important;
            }
            .badge-subtle-secondary {
              line-height: normal;
              text-align:right;
              font-size: 13px;
              border: var(--falcon-border-width) solid var(--falcon-gray-300);
            }    
           `}
        </style>
      </Card.Body>
    </Card>
  );
};

export default FiltersComponentSkeleton;

const OptionLayout = (props: ColumnSelectOptionProps) => {
  const { innerProps, innerRef } = props;
  return (
    <>
      <style>{`
      .customized-searchbox-option:hover{
        background-color:var(--falcon-gray-link-hover-300) !important;
      }
      .customized-searchbox-option{
        background-color:var(--falcon-tertiary-bg) !important;
      }
      `}</style>
      <div
        ref={innerRef}
        {...innerProps}
        style={{
          backgroundColor: props.isSelected
            ? 'var(--falcon-gray-link-hover-100)'
            : 'var(--falcon-dropdown-bg-global)'
        }}
        className="p-2 cursor-pointer border border-1 customized-searchbox-option"
      >
        <div className="text-800  fs--2">{props.data.label}</div>
      </div>
    </>
  );
};
